export * from "./school-chart.component";
